import { Fragment, useEffect, useState } from "react";
import {
  addIndex,
  filter,
  find,
  isEmpty,
  length,
  map,
  path,
  propEq,
  sortBy,
  toUpper
} from "ramda";
import { useIntl } from "react-intl";
import education from "../../../../i18n/definitions/education";
import Typography from "@mui/material/Typography";
import { getRajoitteetFromMaarays } from "@/utils/rajoitteetUtils";
import { getLocalizedProperty } from "@/services/lomakkeet/utils";
import LisatiedotHtmlLupa from "@/components/03-templates/HtmlLupanakyma/Lisatiedot";
import rajoitteet from "../../../../i18n/definitions/rajoitteet";
import { PropTypes } from "prop-types";
import { PaikallisenTietovarastonAvain } from "@/enums";
import localForage from "localforage";

export default function OpetuksenMuutEhdotHtml({ maaraykset }) {
  const intl = useIntl();
  const localeUpper = toUpper(intl.locale);
  const [muutEhdotKoodisto, setMuutEhdotKoodisto] = useState([]);

  /** Fetch Muut ehdot -koodisto from storage */
  useEffect(() => {
    localForage
      .getItem(PaikallisenTietovarastonAvain.LUKIO_MUUT_EHDOT)
      .then(muutEhdotKoodisto => setMuutEhdotKoodisto(muutEhdotKoodisto))
      .catch(err => {
        console.error(err);
      });
  }, []);

  const muutEhdotMaaraykset = sortBy(
    m => parseFloat(`${m.koodiarvo}.${path(["meta", "ankkuri"], m)}`),
    filter(
      maarays =>
        maarays.kohde.tunniste ===
          "muutkoulutuksenjarjestamiseenliittyvatehdot" &&
        maarays.koodisto === "lukiomuutkoulutuksenjarjestamiseenliittyvatehdot",
      maaraykset
    )
  );

  const lisatietomaarays = find(
    maarays =>
      maarays.kohde.tunniste ===
        "muutkoulutuksenjarjestamiseenliittyvatehdot" &&
      maarays.koodisto === "lisatietoja",
    maaraykset
  );

  return !isEmpty(muutEhdotMaaraykset) && !isEmpty(muutEhdotKoodisto) ? (
    <div className="mt-4">
      <Typography component="h3" variant="h3">
        {intl.formatMessage(education.muutEhdotTitle)}
      </Typography>

      <ul className="ml-8 list-disc mb-4">
        {addIndex(map)((maarays, index) => {
          let naytettavaArvo = path(["meta", "kuvaus"], maarays);

          if (!naytettavaArvo) {
            const koodistosta = find(
              propEq("koodiarvo", maarays.koodiarvo),
              muutEhdotKoodisto
            );

            naytettavaArvo = getLocalizedProperty(
              koodistosta.metadata,
              localeUpper,
              "kuvaus"
            );
          }

          return (
            <Fragment key={`${maarays.koodiarvo}-${index}`}>
              <li
                className={`leading-bulletList ${
                  length(maarays.aliMaaraykset) ? "mb-2" : ""
                }`}>
                {naytettavaArvo}
                {length(maarays.aliMaaraykset)
                  ? getRajoitteetFromMaarays(
                      maarays.aliMaaraykset,
                      localeUpper,
                      intl.formatMessage(rajoitteet.ajalla),
                      "kuvaus"
                    )
                  : ""}
              </li>
            </Fragment>
          );
        }, muutEhdotMaaraykset)}
      </ul>
      <LisatiedotHtmlLupa lisatietomaarays={lisatietomaarays} />
    </div>
  ) : null;
}

OpetuksenMuutEhdotHtml.propTypes = {
  maaraykset: PropTypes.array
};
